var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownChevron = function SvgDownChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.65q-.174 0-.337-.05a.6.6 0 0 1-.288-.2L6.85 9.9a.77.77 0 0 1-.2-.525q0-.3.225-.525.225-.2.525-.2t.525.2L12 12.925l4.1-4.075q.2-.224.5-.213.3.014.525.213.225.226.225.537 0 .313-.225.513l-4.5 4.5a.6.6 0 0 1-.287.2q-.162.05-.338.05"
  })));
};
export default SvgDownChevron;